import { createStore, combineReducers } from "redux";

import { bookingReducer } from "./Booking/booking.reducer";
import { dispatchItemReducer } from "./DispatchItem/dispatchItem.reducer";
import { generalInfoReducer } from "./General/general.reducer";
import { collectorInfoReducer } from "./Collector/collector.reducer";

const reducers = combineReducers({
  booking: bookingReducer,
  dispatchItem: dispatchItemReducer,
  generalInfo: generalInfoReducer,
  collectorInfo: collectorInfoReducer,
});

export default createStore((state, action) => reducers(state, action));
